import React, {useState, useEffect} from 'react';
import styled from 'styled-components'
import CustomCheck2 from "../components/CustomCheck2";
import {trackGaussEvent} from "../helper/analytics";


function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}


export default  function RegisterOnline({onSuccess}) {
    const [isDeployed, setIsDeployed] = useState(false)
    const [isAccepted, setIsAccepted] = useState(false)
    const [isErrorAccepted, setIsErrorAccepted] = useState(false)
    const [isErrorName, setIsErrorName] = useState(false)
    const [isErrorEmail, setIsErrorEmail] = useState(false)
    const [isErrorPassword, setIsErrorPassword] = useState(false)
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [isLoading, setIsLoading] = useState(false)
    const [isGeneralError, setIsGeneralError] = useState(false)


    const start = () => {
        setIsDeployed(true)

        trackGaussEvent('start_inline_register', {
        })
    }

    const onSend = () => {
        let validated = true
        if(name.length < 2) {
            setIsErrorName(true)
            validated = false
        } else {
            setIsErrorName(false)
        }

        if(password.length < 8) {
            setIsErrorPassword(true)
            validated = false
        } else {
            setIsErrorPassword(false)
        }

        if(!validateEmail(email)) {
            setIsErrorEmail(true)
            validated = false
        } else {
            setIsErrorEmail(false)
        }

        if(!isAccepted) {
            setIsErrorAccepted(true)
            validated = false
        } else{
            setIsErrorAccepted(false)
        }

        if(!validated) return


        trackGaussEvent('register_inline', {
            email: email
        })

        setIsLoading(true)
        fetch('/ajax/register', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({name, email, password})
        }).then((r) => {

            trackGaussEvent('register_inline_success', {
                email: email
            })

            if(onSuccess) {
                onSuccess()
            } else {
                window.location.reload()
            }
        }).catch(() => {
            setIsGeneralError(true)
            setIsLoading(false)
        })
    }

    if(isLoading) {
        return (
            <LoadingContainer>
                Cargando...
            </LoadingContainer>
        )
    }


    if(isDeployed) {
        return (
            <Container>
                <InputContainer>
                    <Title>Completa el formulario para registrate</Title>
                    <Input onChange={(v) => setName(v.target.value)} error={isErrorName} placeholder={"Nombre"} />
                    <Input onChange={(v) => setEmail(v.target.value)}  error={isErrorEmail} placeholder={"Email"} />
                    <Input onChange={(v) => setPassword(v.target.value)}  error={isErrorPassword} placeholder={"Contraseña"} type="password" />
                    <InputCheckboxContainer>
                        <CustomCheck2 onChange={(v) => setIsAccepted(v)} />
                        <InputCheckboxText error={isErrorAccepted}>Acepto los <a href="/terminos-y-condiciones" target="_black">Términos
                            y Condiciones</a> y la  <a href="/politica-de-privacidad" target="_black">Política
                            de Privacidad</a>.</InputCheckboxText>
                    </InputCheckboxContainer>

                    {isGeneralError && (<GeneralError>Ha habido un problema, ¿quizás ya estás registrado?</GeneralError>)}

                    <ButtonContainer>
                        <div onClick={onSend} className="button">Registro gratuito</div>
                    </ButtonContainer>

                </InputContainer>

            </Container>
        )
    }

    return (
        <RegisterMessage><a href="/register">Regístrate</a> o <a href="/login">loguéate</a> para acceder al contenido</RegisterMessage>
    )
}

const GeneralError = styled.div`
    color: red;
    padding-top: 12px;
    padding-bottom: 12px;
`

const LoadingContainer = styled.div`
    color: white;
    text-align: center;
    padding-top: 24px;
`
const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
`
const InputCheckboxContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding-top: 12px;
    padding-bottom: 12px;
`

const InputCheckboxText = styled.div`
    ${props => props.error ? 'color: red;' : ''}
`
const Title = styled.div`
    text-align: center;
    font-size: 18px;
    color: #FA9F63;
`

const InputContainer = styled.div`
    display: flex;
    flex-direction: column;

`
const Container = styled.div`
    padding: 16px;
    max-width: 640px;
    margin: auto;
`

const Input = styled.input`
    margin-top: 12px;
    ${props => props.error ? 'border:1px solid red;' : ''}
`


const RegisterMessage = styled.div`
    color:#FA9F63;
    text-align: center;
    padding-top: 36px;
`
